// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","logo":"Header_logo__eQM7L"};